<template>
  <div>
    <b-row>
      <SelectField
        v-if="meta && !meta.product"
        v-model="productId"
        class="col-12"
        :label="__('common.product')"
        name="product_id"
        :options="products"
        @onChange="productSelected"
      />

      <TextField
        v-model="commission"
        class="col-4"
        name="commission"
        :label="__('common.agent-commission') + ', %'"
        type="number"
      />
      <TextField
        v-model="grossAmount"
        class="col-4"
        name="gross_amount"
        :label="__('common.gross-commission')"
        type="number"
      />
      <TextField
        v-model="feeAmount"
        class="col-4"
        name="fee_amount"
        :label="__('entities.fee')"
        type="number"
      />
      <DateField
        v-if="isEntityProductHistoryEnabled"
        v-model="activeFrom"
        class="col-4"
        name="active_from"
        :label="__('entities.active-from')"
      />
    </b-row>

    <div class="text-right">
      <b-button size="sm" variant="primary" @click="submit">
        <Icon icon="save" size="14" class="mr-2" />
        {{ __('buttons.save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import EntityProductService from '@/Modules/Entity/EntityProduct/EntityProductService.js'
import ProductService from '@/Modules/Product/ProductService.js'
import { ENTITY_PRODUCT_HISTORY_GETTER } from '@/Modules/Base/SettingModule.js'

export default {
  name: 'LinkProductModal',

  mixins: [ModalMixin],

  props: {
    meta: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      productId: null,
      products: [],
      commission: null,
      grossAmount: null,
      feeAmount: null,
      activeFrom: new Date(),
      activeUntil: null,
      status: 'active',
      statusOptions: [
        { value: 'active', label: 'Active' },
        { value: 'disabled', label: 'Disabled' },
      ],
    }
  },

  computed: {
    isEntityProductHistoryEnabled() {
      return this.$store.getters[`SettingModule/${ENTITY_PRODUCT_HISTORY_GETTER}`]
    },
  },

  created() {
    ProductService.getUnlinked(this.$route.params.entityId).then(
      (items) => (this.products = items.data)
    )

    if (this.meta.product) {
      this.commission = this.meta.product.commission
      this.grossAmount = this.meta.product.grossAmount
      this.feeAmount = this.meta.product.feeAmount
      this.activeFrom = this.meta.product.activeFrom
      this.activeUntil = this.meta.product.activeUntil
      this.status = this.meta.product.status
      this.productId = this.meta.product.productId
    }
  },

  methods: {
    submit () {
      if (this.meta.product) {
        EntityProductService
            .update(this.meta.product.id, {
              commission: this.commission,
              grossAmount: this.grossAmount,
              feeAmount: this.feeAmount,
              ...(this.isEntityProductHistoryEnabled ? {
                activeFrom: this.activeFrom,
                activeUntil: this.activeUntil,
                status: this.$selectValue(this, 'status'),
              } : {}),
            })
            .then(() => {
              this.onSuccess && this.onSuccess()
              this.closeModal(this.__(`entities.product-update-success`))
            })
            .catch(error => this.setErrorsFromResponse(error))

        return
      }
      EntityProductService
          .create(this.$route.params.entityId,
              {
                productId: this.$selectValue(this, 'productId'),
                commission: this.commission,
                grossAmount: this.grossAmount,
                feeAmount: this.feeAmount,
                activeFrom: this.activeFrom,
                activeUntil: this.activeUntil,
                status: this.$selectValue(this, 'status')
              })
          .then(() => {
            this.onSuccess && this.onSuccess()
            this.closeModal(this.__(`entities.product-link-success`))
          })
          .catch(error => this.setErrorsFromResponse(error))
    },

    productSelected (product) {
      this.commission = product.meta.commission
    }
  }
}
</script>
